import React, { useId } from 'react';
import type { ChatConversationProps } from './ChatConversation';
import { ChatConversation } from './ChatConversation';
import { VBox } from '../layout';
import { intl } from '../../lib';
import { List } from '../basic';
import type { EmojiData } from 'emoji-picker-react/src/types/exposedTypes';

export type ChatConversationListProps = {
  conversations: Array<ChatConversationProps>;
  selectedRoomId: string | null;
  setSelectedRoomId: (id: string) => void;
  emojiData?: EmojiData;
};

export function ChatConversationList(
  props: ChatConversationListProps
): React.JSX.Element {
  const listId = useId();

  return (
    <VBox className="ehs-chat-conversation-list">
      <h2 id={listId}>{intl('common.chatmessage.title')}</h2>
      <List aria-labelledby={listId} background={false} divider={'none'}>
        {props.conversations.map(conv => {
          return (
            <ChatConversation
              key={conv.roomId ?? conv.header.toLowerCase().trim()}
              {...conv}
              selected={props.selectedRoomId === conv.roomId}
              role="listitem"
              emojiData={props.emojiData}
              userState={conv.userState}
            />
          );
        })}
      </List>
    </VBox>
  );
}
